// @ts-strict-ignore
import { ITEM_CUSTOMIZATIONS, ITEM_TYPES } from '@/trendData/trendData.constants';
import { isStringSeries } from '@/utilities/utilities';
import _ from 'lodash';
import { TREND_TOOLS } from '@/toolSelection/investigate.constants';
import { WORKSHEET_VIEW } from '@/worksheet/worksheet.constants';
import { sqScatterPlotStore } from '@/core/core.stores';

/**
 * This function was created here to ease function mocking
 *
 * Determine if a customization is enabled for an item. A control is enabled if it could be possible for a certain
 * type of item to be used
 */
export function customizationEnabled(item, property: string, viewKey: string | undefined) {
  const specialExclusions = [];
  if (item.itemType === ITEM_TYPES.SERIES && (item.isStringSeries || item.isCustomizationHidden)) {
    specialExclusions.push('axisAutoScale', 'yAxisMin', 'yAxisMax', 'yAxisType');
  }

  if (item.calculationType === TREND_TOOLS.FFT_TABLE) {
    specialExclusions.push('stack');
  }

  if (viewKey === WORKSHEET_VIEW.SCATTER_PLOT) {
    specialExclusions.push('lane');
    if (isStringSeries(item) || item.itemType === ITEM_TYPES.METRIC) {
      specialExclusions.push('axisAlign');
    }

    if (!sqScatterPlotStore.isFxLine(item.id)) {
      specialExclusions.push('lineWidth');
    }
  }

  return !_.includes(specialExclusions, property) && _.includes(ITEM_CUSTOMIZATIONS[item.itemType], property);
}
